import { hasPayloadProgress } from '~/utils/societePayloadBuilder/hasProgress';

import { createDefaultPromoBannerCarouselState } from './defaults';
import type { LuxPlusPromoBannerCarouselState } from './types';

function snapshotPromoBannerCarouselState(state: LuxPlusPromoBannerCarouselState): string {
  return JSON.stringify({
    promos: state.promos.map((promo) => ({
      label: promo.label.trim(),
      title: promo.title.trim(),
      ctaText: promo.ctaText.trim(),
      ctaLink: promo.ctaLink.trim(),
      ctaLinkType: promo.ctaLinkType,
      expiresAt: promo.expiresAt.trim(),
      eligibleRegions: [...promo.eligibleRegions].sort(),
    })),
  });
}

export function hasPromoBannerCarouselProgress(state: LuxPlusPromoBannerCarouselState, loadJson: string): boolean {
  return hasPayloadProgress(state, loadJson, createDefaultPromoBannerCarouselState, snapshotPromoBannerCarouselState);
}
